import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background:
    radial-gradient(circle at 20% 50%, rgba(245, 138, 138, 0.2) 0%, transparent 55%),
    radial-gradient(circle at 50% 50%, rgba(166, 108, 217, 0.16) 0%, transparent 55%),
    radial-gradient(circle at 80% 50%, rgba(91, 91, 255, 0.2) 0%, transparent 55%),
    linear-gradient(180deg, #f8f9fc 0%, #f0f2fa 100%);
  padding: 60px 20px;
  position: relative;
  overflow: hidden;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 80px 30px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 100px 40px;
  }

  .inner {
    max-width: 820px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 1;
  }

  .headline {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 24px;
    line-height: 1.25;
    letter-spacing: -0.015em;
    color: ${CSSVars.black};
    margin: 0 0 24px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 30px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 36px;
    }
  }

  .cta {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 16px;
    color: ${CSSVars.white};
    text-decoration: none;
    padding: 16px 34px;
    border-radius: 999px;
    background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.purple500} 50%, ${CSSVars.blue500} 100%);
    background-size: 200% 100%;
    background-position: 100% 0;
    transition: background-position 0.4s ease, transform 0.2s ease,
      box-shadow 0.2s ease;
    box-shadow: 0 8px 24px rgba(91, 91, 255, 0.32);

    &:hover {
      background-position: 0 0;
      transform: translateY(-2px);
      box-shadow: 0 12px 32px rgba(245, 138, 138, 0.4);
    }

    span {
      transition: transform 0.2s ease;
    }
    &:hover span {
      transform: translateX(3px);
    }

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 17px;
      padding: 18px 38px;
    }
  }

  .microcopy {
    font-family: ${CSSVars.secondaryFont};
    font-size: 13px;
    color: #6b7280;
    margin: 18px 0 0;
  }
`;
